<template>
    <div>
        <div v-if="robotItem.stage === 'tool_score'">
            tool_score
            <div v-if="Array.isArray(robotItem.content.tools) && robotItem.content.tools.length > 0">
                <h3>
                    The top ranked tools are listed:
                </h3>
                <tool-vue :data="robotItem.content.tools"/>
            </div>
            <div v-else>No tools</div>
        </div>
        <div v-else-if="robotItem.workflow === 'mermaid' ">
            <mermaid-component :data="robotItem.content" :task="robotItem.task_id"></mermaid-component>
        </div>


        <div v-else-if="robotItem.workflow === 'tools' ">
            <h3>
                The top ranked tools are listed:
            </h3>
            <tool-vue :data="robotItem.content"/>
        </div>
        <div v-else-if="robotItem.workflow === 'workflow' ">
            <code-data :data="robotItem?.content"></code-data>
        </div>
        <div v-else-if="robotItem.code === 'code_info'">
            <code-info :data="robotItem.content"></code-info>
        </div>
        <div v-else-if="robotItem.code === 'time'">
            <div>
                Invoke the code{{robotItem.action+1}} program to run.
            </div>
            <div v-if="robotItem.content.length > 1">
                Code {{robotItem.action+1}} <span style="color:#E54C5E">failed</span>, attempting to automatically update parameters.
                <div v-for="(tt,tIndex) in robotItem.content" :key="tIndex">
                    {{tIndex + 2}} attempt after code{{robotItem.action+1}} failure.
                </div>
            </div>

            Code {{robotItem.action+1}} ran <span style="color:#75BD42">successfully</span>.
        </div>
        <div v-else-if="robotItem.completed === 'zip_path'">
            Task completed<span v-if="robotItem.content">
                ，下载<a @click="downFile(robotItem.content)" target="_blank">结果文件</a>
            </span><span v-else>.</span>
        </div>
        <div v-else-if="robotItem.stage === 'code'">
            {{robotItem.stage}}-{{robotItem[robotItem.stage]}}: 其他数据
        </div>
        <span v-else-if="robotItem.stage === 'failed'">
            <code-data :data="'```' + robotItem.content+ '```' "></code-data>
        </span>
        <div v-else>
            <code-data :data="robotItem?.content || robotItem"></code-data>
        </div>
    </div>
</template>

<script>
    import {onMounted, ref} from 'vue';
    // import mermaid from 'mermaid';
    import CodeData from "../components/CodeData";
    import MermaidComponent from "../components/MermaidComponent";
    import ToolVue from "./ToolVue";
    import CodeInfo from "./CodeInfo";
    import {down_file} from "../utils/request";
    const mermaidContainer = ref(null);
    console.log('mermaidContainer', mermaidContainer);
    export default {
        name: "RobotContent",
        props: ['data'],
        components: {
            ToolVue,
            'code-data': CodeData,
            'tool-vue': ToolVue,
            'code-info': CodeInfo,
            'mermaid-component': MermaidComponent
        },
        data (){
            return {
                robotItem: this.data,
            }
        },
        methods: {
            downFile(file_path){
                down_file({file_path});
            }
        },
        watch: {
            data(newVal){
                this.robotItem = newVal;
            }
        },
        setup(){
            // let {robotItem} = this;
            onMounted(function(){

                // mermaid.initialize({
                //     theme: 'forest',
                // });
                // mermaid.init(undefined, '#mermaidGraph');
            })
        }
    }
</script>

<style>

</style>
